import { render } from "./Education.vue?vue&type=template&id=569da790"
import script from "./Education.vue?vue&type=script&lang=js"
export * from "./Education.vue?vue&type=script&lang=js"
script.render = render

export default script